"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardWarningBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var CardWarningBanner = /** @class */ (function (_super) {
    __extends(CardWarningBanner, _super);
    function CardWarningBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.togglePopup = function () {
            _this.props.interaction.uistate.paymentCardTypeIsCorrect = true;
            _this.setState({ showBanner: false });
        };
        _this.navigateToChangePaymentCard = function () {
            window.sessionStorage.setItem("renewalInteraction", _this.props.interaction._id);
            window.sessionStorage.setItem("redirectJourney", "renewal");
            window.sessionStorage.setItem("product", "annualMotor");
            window.location.assign("/dashboard/account/changeCard/" + _this.props.interaction.agreementNumber);
        };
        _this.state = {
            showBanner: true
        };
        return _this;
    }
    CardWarningBanner.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.togglePopup });
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "falcon-modal", isOpen: this.state.showBanner, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.togglePopup, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex gdpr-title-format", children: [(0, jsx_runtime_1.jsx)("img", { src: "/img/attention_icon_blue.png", alt: "Attention", width: 40, height: 40 }), (0, jsx_runtime_1.jsx)("span", { className: "ml-3 banner-text", children: "We can only accept monthly payment by debit card" })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", children: (0, jsx_runtime_1.jsxs)("div", { className: "widget personalInfo-widget gdpr-popup-text-format", children: [(0, jsx_runtime_1.jsx)("p", { children: "You used a credit card when you paid in full for your policy last year." }), (0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold", children: "Because you've changed to monthly payments for next year, we need you to use a debit card." })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "justify-content-center flex-column pl-5 pr-5 pb-3", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-next w-100", onClick: this.navigateToChangePaymentCard, children: "Change payment card" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-white w-100 mb-0", onClick: this.togglePopup, children: "Cancel changes" }) })] })] }) }));
    };
    ;
    return CardWarningBanner;
}(plugin_journey_1.WidgetBase));
exports.CardWarningBanner = CardWarningBanner;
//# sourceMappingURL=CardWarningBanner.js.map